import { render, staticRenderFns } from "./CardDeckCollaborationsConfirmationModal.vue?vue&type=template&id=4a650d5d&"
import script from "./CardDeckCollaborationsConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./CardDeckCollaborationsConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports